import { render, staticRenderFns } from "./DetailDepartment.vue?vue&type=template&id=efc192bc&scoped=true&"
import script from "./DetailDepartment.vue?vue&type=script&lang=js&"
export * from "./DetailDepartment.vue?vue&type=script&lang=js&"
import style0 from "./DetailDepartment.vue?vue&type=style&index=0&id=efc192bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc192bc",
  null
  
)

export default component.exports